import { EVENT_TYPE } from "../../AnalyticsTracking/events";
import { setCookie } from "../../Shared/Assets/src/cookie";
import { emitEvent } from "../../Shared/Assets/src/tagmanager";
import { CloseModalEvent, initializeModal } from "../../Shared/Modal/modal";
import { isNullOrWhiteSpace } from "../../Shared/Utilities/string";

document.querySelectorAll<HTMLElement>("[data-campaign-popup]").forEach(modal => {
  const enabled = modal.dataset.enabled === "true";

  if (enabled) {
    const campaignCode = modal.dataset.campaignCode;

    const cookieExpirationDays = !isNullOrWhiteSpace(modal.dataset.cookieExpirationDays)
      ? parseInt(modal.dataset.cookieExpirationDays)
      : undefined;

    const dismissCookieName = modal.dataset.dismissCookieName;

    const displayTime = !isNullOrWhiteSpace(modal.dataset.displayTime)
      ? parseInt(modal.dataset.displayTime)
      : undefined;

    const snoozeCookieName = modal.dataset.snoozeCookieName;

    const links = modal.querySelectorAll<HTMLLinkElement>("a");

    if (cookieExpirationDays && dismissCookieName && displayTime && snoozeCookieName) {
      const modalDefinition = initializeModal(modal);

      setTimeout(() => {
        modalDefinition.open();
      }, displayTime * 1000);

      links.forEach(link =>
        link.addEventListener("click", e => {
          setCookie(dismissCookieName, "hide", cookieExpirationDays);

          if (campaignCode) {
            // Send event to GTM
            emitEvent(EVENT_TYPE.campaignPopupClick, { campaignCode }, false);
          }
        })
      );

      modal.addEventListener("modal:close", e => {
        const event = e as CloseModalEvent;
        const target = event.detail.originalEvent?.currentTarget;

        if (target instanceof HTMLElement && target.dataset.closeButton !== undefined) {
          // Dismiss popup for X amount of days if explicitly hitting the close button, otherwise just snooze it for
          // the current session (clicking outside the modal or hitting ESC).
          setCookie(dismissCookieName, "hide", cookieExpirationDays);
        } else {
          setCookie(snoozeCookieName, "hide", 0);
        }
      });
    }
  }
});
